import { Injectable } from '@angular/core';
import { JwtDecoded } from '../models/jwt-decoded';
import { jwtDecode } from 'jwt-decode'


@Injectable({
  providedIn: 'root'
})
export class JwtServiceService {

  constructor() { }
  DecodeToken(token: string): JwtDecoded {
    return jwtDecode(token) as JwtDecoded;
    }
}


